import { Button,  SelectChangeEvent } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading';
import ConfigurationHeader from '../../components/heading/ConfigurationHeader';
import { CameraImage, DashboardCheckbox, DashboardSelect } from '../../components/Input/Input';
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getClientConfigFilters, getFilters, getMetaData, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration, validateMetaDataResponse } from '../../services/uiConfigService';
import { configurationAttributeType, defaultCatalogueSortingvalues, newConfigurationNames, sortingOptions } from '../../types';
import { catalogueValueTypes, metaDataBatchPayload, popupType } from '../../types/types';
import { IndentWrapper } from '../orderConfiguration/OrderConfiguration';
import Input from "../../components/Input/Input"
import "./CatalogueConfiguration.css";
import * as yup from 'yup';
import store from '../../stateManagement/store';
import { createBlobKey } from '../../utils/utils';
import * as Sentry from "@sentry/react";
import QuestionHeading from '../../components/heading/QuestionHeading';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { defaultCatalogueInputValues, defaultCatalogueSortingConfig } from '../defaultConfigurations/catalogueConfigDefaultValues';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import ConfigComparePopup from '../../components/popup/ConfigComparePopup';
import ImportConfig from '../../components/importConfig/ImportConfig';
import { updateConfigRequestBody } from '../../services/managePoliciesService';
import { getLob } from '../../services/authenticationService';
import { META_DATA_BATCH_API } from '../../services/networkService';


const CatalogueConfiguration = () => {
    const [catalogueConfig, setCatalogueConfig] = useState<configurationAttributeType[]>([]);
    const [catalogueSortingConfig, setCatalogueSortingConfig] = useState<configurationAttributeType<sortingOptions[]>>(defaultCatalogueSortingConfig.catalogueSortingConfig);
    const [values, setValues] = useState<catalogueValueTypes>(deepClone(defaultCatalogueInputValues))
    const [defaultCatalogueImage, setDefaultCatalogueImage] = useState<string | File>();
    const [dummyCouponImage, setDummyCouponImage] = useState<string | File>()
    const [dummyItemCouponImage, setDummyItemCouponImage] = useState<string | File>()
    const [catalogueValidationsSchema, setCatalogueValidationSchema] = useState({})
    const [filterValues, setFilterValues] = useState({
        filter1: '',
        filter2: '',
        filter3: '',
    })
    const [filterOptions] = useState([
        { value: 'brand', title: "Brand" },
        { value: 'category', title: "Category" },
        { value: 'subCategory', title: "Sub category" },
        { value: 'subBrand', title: "Sub Brand" },
        { value: 'brandCode', title: "Brand Code" },
        { value: 'pieceSize', title: "Pack size" },
        { value: 'none', title: "None" }
    ])

    const [showConfigPopup,setShowConfigPopup] = useState<boolean>(false);
    const curConfigRef = useRef<{[key:string]:any[]}>({});
    const newConfigRef = useRef<{[key:string]:any[]}>({});

    const getCatalogueConfiguration = async () => {
        try {
            const resp = await getNewConfiguration('catalogue_configuration');
            const catalogue_config: configurationAttributeType[] = resp?.domainValues;
            let catalogueCurrentConfigs:{[key:string]:any[]} = {
                "tab_filters":[],
                "catalogue_configuration":[],
                "catalogue_sorting_options":[],
            };
            setCatalogueConfig([...catalogue_config])
            const sorting_config_resp = await getNewConfiguration('catalogue_sorting_options');
            // const filterResp = await getMetaData('filters', 'tab')
            const filterResp = await getNewConfiguration('tab_filters');
            const filters=filterResp.domainValues[0].value;
            if (filters) {
                setFilterValues({
                    filter1: filters?.[0]?.name ? filters?.[0]?.name:'none',
                    filter2: filters?.[1]?.name ? filters?.[1]?.name:'none',
                    filter3: filters?.[2]?.name ? filters?.[2]?.name:'none',
                })
            }
            const sorting_config: configurationAttributeType<sortingOptions[]>[] = sorting_config_resp?.domainValues;
            setCatalogueSortingConfig({...sorting_config[0]});

            const tabFilterConfigObj =filterResp.domainValues[0];
            catalogueCurrentConfigs.tab_filters=[tabFilterConfigObj];
            catalogueCurrentConfigs.catalogue_configuration=catalogue_config??[];
            catalogueCurrentConfigs.catalogue_sorting_options=sorting_config ?? [];
            curConfigRef.current = catalogueCurrentConfigs;
        } catch (err) {
            // Sentry.captureException(err);

        }
    }
    useEffect(() => {
        getCatalogueConfiguration();
    }, [])

    const getValuesWithBlobKey = async () => {
        const returnValues={...values}
        let blobKey = undefined;
        try {
            if (dummyCouponImage) {
                const fileArr = [];
                dummyCouponImage && fileArr.push(dummyCouponImage);
                const blobKeyResp = await createBlobKey(fileArr as File[], 'admin');
                returnValues.dummyCouponImage.value = blobKeyResp?.[0]?.Uri ? blobKeyResp?.[0]?.Uri : returnValues.dummyCouponImage.value;
                returnValues.dummyCouponImage.isValueUpdated = true
            }
            if (dummyItemCouponImage) {
                const fileArr = [];
                dummyItemCouponImage && fileArr.push(dummyItemCouponImage);
                const blobKeyResp = await createBlobKey(fileArr as File[], 'admin');
                returnValues.dummyItemCouponImage.value = blobKeyResp?.[0]?.Uri ? blobKeyResp?.[0]?.Uri : returnValues.dummyItemCouponImage.value;
                returnValues.dummyItemCouponImage.isValueUpdated = true
            }
            if (defaultCatalogueImage) {
                const fileArr = [];
                defaultCatalogueImage && fileArr.push(defaultCatalogueImage);
                const blobKeyResp = await createBlobKey(fileArr as File[], 'admin');
                returnValues.defaultCatalogueImage.value = blobKeyResp?.[0]?.Uri ? blobKeyResp?.[0]?.Uri : returnValues.defaultCatalogueImage.value;
                returnValues.defaultCatalogueImage.isValueUpdated = true
            }
            return { ...returnValues };
        } catch (err) {
            // Sentry.captureException(err);
            return {
                ...values
            }
        }
    }
    const saveConfiguration = async (preview?: boolean) => {

            try {
                const resultantValues = await getValuesWithBlobKey();
                
                const catalogueSchema = yup.object({ ...catalogueValidationsSchema })
                const validationObject:any = {};
                Object.keys(resultantValues).forEach(key=>{
                    validationObject[key] = resultantValues[key].value;
                })
                // await catalogueSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(resultantValues, catalogueConfig);
                const catalogueNewConfigs:{[key:string]:any[]} = {
                    "tab_filters":[],
                    "catalogue_configuration":[],
                    "catalogue_sorting_options":[],
                };
                catalogueNewConfigs.catalogue_configuration=convertedVals??[];

                const newTabFilterObj =  getClientConfigFilters(filterValues)
                catalogueNewConfigs.tab_filters=newTabFilterObj;
                catalogueNewConfigs.catalogue_sorting_options=[catalogueSortingConfig];
                newConfigRef.current = catalogueNewConfigs;
                setShowConfigPopup(true);
            } catch (err) {
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup('Error',"Error occured : " + err?.message)
            }
    }
    function getFinalMetaDataPayload(){
        const lob = getLob();
        const catalogueDataPayload: updateConfigRequestBody = {
            domainName: "clientconfig",
            domainType: "catalogue_configuration",
            domainValues: newConfigRef.current.catalogue_configuration,
            lob
        }
        const finalMetaDataPayload: metaDataBatchPayload = { features: [catalogueDataPayload]};
        const tabFilterPayload: updateConfigRequestBody= {
            domainName: "filters",
            domainType: "tab",
            domainValues: getFilters(filterValues) as any[],
            lob
        };
        finalMetaDataPayload.features.push(tabFilterPayload);
        const filterPayload: updateConfigRequestBody = {
            domainName: "clientconfig",
            domainType: "tab_filters",
            domainValues: getClientConfigFilters(filterValues),
            lob
        };
        finalMetaDataPayload.features.push(filterPayload);
        const catalogueSortingDataPayload: updateConfigRequestBody = {
            domainName: "clientconfig",
            domainType: "catalogue_sorting_options",
            domainValues: newConfigRef.current.catalogue_sorting_options,
            lob
        }
        finalMetaDataPayload.features.push(catalogueSortingDataPayload);
        return finalMetaDataPayload;
    }
    async function doFinalCatalogueConfigSubmit(){
        const finalMetaDataPayload = getFinalMetaDataPayload();
        validateWithOtp(async (verifiedUser?: manageUpdateAccessObj,verifyResponse?: any)=>{
            try{
                if(verifyResponse.status >= 200 || verifyResponse.status < 300){
                    const validationObj = validateMetaDataResponse(verifyResponse?.data?.features);
                    if(validationObj.success){
                        openPopup('Success',"Configuration Updated")
                        curConfigRef.current = {...newConfigRef.current};
                        getCatalogueConfiguration();
                    }else{
                        openPopup("Error",validationObj.message);
                    }
                    
                }else{
                    throw new Error("Something went wrong");
                }
            }catch(err){
                // Sentry.captureException(err);
                if(err instanceof Error)
                    openPopup("Error",err?.message);
            }
        },undefined,"admin",META_DATA_BATCH_API,finalMetaDataPayload,"PUT");
        // return true;
    }
    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.checked, isValueUpdated:true} 
        })
    }

    const handleSortingCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        // const sortingConfig={...catalogueSortingConfig};
        let updatedValues:sortingOptions[]=[...catalogueSortingConfig.value];
        if(event.target.checked){
            updatedValues.push(catalogueSortingConfig.possibleVals.find((sortingObject:sortingOptions)=>sortingObject.name === event.target.name))
        }else{
            updatedValues = catalogueSortingConfig.value.filter((sortingObject:sortingOptions)=>sortingObject.name !== event.target.name);
        }
        setCatalogueSortingConfig({...catalogueSortingConfig,value:updatedValues});

        console.log('hey',{...catalogueSortingConfig,value:updatedValues});
        // setCatalogueSortingConfig({...catalogueSortingConfig,value:updatedValue});
    }

    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

    const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

    const handleFilterValueChange = (e: SelectChangeEvent<any>) => {
        if (e.target.name === "filter1" && filterValues.filter1 === "none") {
            setFilterValues({
                ...filterValues,
                filter1: e.target.value,
            })
        }
        else if (e.target.name === "filter2" && filterValues.filter1 === "none") {
            setFilterValues({
                ...filterValues,
                filter1: e.target.value,
            })
        }
        else
            setFilterValues({
                ...filterValues,
                [e.target.name]: e.target.value
            })
    }

    const setCatalogueConfigValues = () => {
        try {
            if (catalogueConfig.length) {
                const result = { ...values };
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                catalogueConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr;
                })
                setValues({ ...result });
                // const sortingFilter = result?.catalogueSortingOrder
                // if (sortingFilter?.length)
                //     setFilterValues({
                //         filter1: sortingFilter?.[0],
                //         filter2: sortingFilter?.[1],
                //         filter3: sortingFilter?.[2],
                //     })
                setCatalogueValidationSchema({ ...resValidations })
            }
        } catch (err) {
            // Sentry.captureException(err);
        }
    }

    // const handleResetFilter = () => {
    //     setFilterValues({
    //         filter1: '',
    //         filter2: '',
    //         filter3: ''
    //     })
    // }
    useEffect(() => {
        setCatalogueConfigValues();
    }, [catalogueConfig])
    // useEffect(() => {
    //     if (filterValues.filter1 || filterValues.filter2 || filterValues.filter3)
    //         setValues((prevValues) => ({
    //             ...prevValues,
    //             catalogueSortingOrder: [filterValues.filter1, filterValues.filter2, filterValues.filter3]
    //         }))
    //     else
    //         setValues((prevValues) => ({
    //             ...prevValues,
    //             catalogueSortingOrder: []
    //         }))
    // }, [filterValues])


    const importConfiguration = async (importedConfig:any)=>{
        const newConfigs = await overWriteConfig(importedConfig, {
            tab_filters:"importAll",
            catalogue_configuration: "importAll",
            catalogue_sorting_options: "importAll"
        })
        newConfigs.forEach((item) => {
            newConfigRef.current[item.domainType] = item.domainValues;
        });
            const filters=newConfigRef?.current?.tab_filters[0]?.value;
            if (filters) {
                setFilterValues({
                    filter1: filters?.[0]?.name ? filters?.[0]?.name:'none',
                    filter2: filters?.[1]?.name ? filters?.[1]?.name:'none',
                    filter3: filters?.[2]?.name ? filters?.[2]?.name:'none',
                })
            }
        setShowConfigPopup(true);
    }
    const [importConfigState,setImportConfigState] = useState(false);



    return (
        <div className='catalogue_configuration_container'>
            <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['tab_filters','catalogue_configuration','catalogue_sorting_options']} importConfigCallback={importConfiguration} />
            <ConfigurationHeader heading={"Catalogue Configuration"} importConfiguration={()=>{setImportConfigState(true)}} saveConfiguration={() => saveConfiguration(false)} />
            <div className="config_form_container">

            <div className="form_header">
                <BorderHeading>Tab Filters configuration</BorderHeading>
            </div>

            <IndentWrapper indent={0}>
                    <QuestionHeading>
                        what should be the first filter for catalogue filtering?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleFilterValueChange} value={filterValues.filter1} name="filter1" options={filterOptions.filter(opt => {
                            return (opt.value !== filterValues.filter2 && opt.value !== filterValues.filter3) || opt.value === "none"
                        })} selectLableId='Filter 1' />
                    </div>

                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        what should be the second filter for catalogue filtering?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleFilterValueChange} disabled={filterValues.filter1 === "none"} value={filterValues.filter2} name="filter2" options={filterOptions.filter(opt => {
                            return (opt.value !== filterValues.filter1 && opt.value !== filterValues.filter3) || opt.value === "none"
                        })} selectLableId='Filter 2' />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        what should be the third filter for catalogue filtering?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleFilterValueChange} disabled={filterValues.filter1 === "none" || filterValues.filter2 === "none"} value={filterValues.filter3} name="filter3" options={filterOptions.filter(opt => {
                            return (opt.value !== filterValues.filter1 && opt.value !== filterValues.filter2) || opt.value === "none"
                        })} selectLableId='Filter 3' />
                    </div>

                </IndentWrapper>






                <div className="form_header">
                    <BorderHeading>Catalogue view configuration</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    couponFilterVisibility
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.couponFilterVisibility.value} onChange={handleCheckChange} name="couponFilterVisibility" label="Yes" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    showScanButton
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.showScanButton.value} onChange={handleCheckChange} name="showScanButton" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    pieceSizeVisibility
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.pieceSizeVisibility.value} onChange={handleCheckChange} name="pieceSizeVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    caseToPieceVisibility
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.caseToPieceVisibility.value} onChange={handleCheckChange} name="caseToPieceVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    multiVariantOrder
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.multiVariantOrder.value} onChange={handleCheckChange} name="multiVariantOrder" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    bundleCouponVisibility
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.bundleCouponVisibility.value} onChange={handleCheckChange} name="bundleCouponVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    caseToPieceLabel
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.caseToPieceLabel.value} onChange={handleValueChange} name="caseToPieceLabel" />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    ptrVisibility
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.ptrVisibility.value} onChange={handleValueChange} name="ptrVisibility" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    pieceSizeLabel
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.pieceSizeLabel.value} onChange={handleValueChange} name="pieceSizeLabel" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What should be SKU description format?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect value={values.skuDescriptionFormatter.value} options={values.skuDescriptionFormatter.possibleVals} onChange={handleSelectValueChange} name="skuDescriptionFormatter" selectLableId="skuDescriptionFormatter" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What should be the unit label for CASE?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.caseUnitLabel.value} onChange={handleValueChange} name="caseUnitLabel" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What should be the unit label for PTR?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.ptrLabel.value} onChange={handleValueChange} name="ptrLabel" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What should be the unit label for MRP?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.mrpLabel.value} onChange={handleValueChange} name="mrpLabel" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What should be the unit label for CASE PTR?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.casePtrLabel.value} onChange={handleValueChange} name="casePtrLabel" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What should be the unit label for UNIT?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.unitLabel.value} onChange={handleValueChange} name="unitLabel" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What should be the unit label for PACK?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.packUnitLabel.value} onChange={handleValueChange} name="packUnitLabel" />
                    </div>
                </IndentWrapper>


                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What should be the unit label for Other?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.otherUnitLabel.value} onChange={handleValueChange} name="otherUnitLabel" />
                    </div>
                </IndentWrapper>


                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        What should be the unit label  for Pack PTR?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.packPtrLabel.value} onChange={handleValueChange} name="packPtrLabel" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Can user have the option to save the SKU in favourites ?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.favouriteSKU.value} onChange={handleCheckChange} name="favouriteSKU" label="Yes" />
                    </div>
                </IndentWrapper>

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want automatic UOM conversion?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.autoUOMConversion} onChange={handleCheckChange} name="autoUOMConversion" label="Yes" />
                    </div>
                </IndentWrapper> */}

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you wish to display Suggested quantity?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.suggestedQtyVisibility.value} onChange={handleCheckChange} name="suggestedQtyVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want pack size to be visible?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.unitVisibility} onChange={handleCheckChange} name="unitVisibility" label="Yes" />
                    </div>
                </IndentWrapper> */}

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want to enable Multi UOM order?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.multiUOMSelection.value} onChange={handleCheckChange} name="multiUOMSelection" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want  SKU  code to be visible in description?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.skuCodeVisibility.value} onChange={handleCheckChange} name="skuCodeVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                {values.skuCodeVisibility && <>
                    <IndentWrapper indent={2}>
                    <QuestionHeading>
                    How many digits of SKU should the user be able to see?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.skuCodeCondition.value} onChange={handleValueChange} name="skuCodeCondition" />
                    </div>
                    </IndentWrapper>

                </>}
                
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want that suggested quantity to be added to cart by default ?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.orderSuggestedQty.value} onChange={handleCheckChange} name="orderSuggestedQty" label="Yes" />
                    </div>
                </IndentWrapper>

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want to maximum discount to be visible?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values.maxDiscountVisibility} name="maxDiscountVisibility" label="Yes" />
                    </div>
                </IndentWrapper> */}

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want to display price?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.displayPrice} onChange={handleCheckChange} name="displayPrice" label="Yes" />
                    </div>
                </IndentWrapper> */}

                <div className="form_header">
                    <BorderHeading>Dummy product upload</BorderHeading>
                </div>


                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Upload the  image  you wish to display when no image is available for the SKU
                    </QuestionHeading>
                    <div className="generic_form_container">
                        <CameraImage image={defaultCatalogueImage as string} setImage={setDefaultCatalogueImage} currImage={values.defaultCatalogueImage.value} />
                        <span className="resolution_text">*The image resolution should be 500x500</span>
                        <Button variant="contained" onClick={() => { setValues({ ...values, defaultCatalogueImage: {...values.defaultCatalogueImage, value:"",isValueUpdated:true} });
                            setDefaultCatalogueImage(undefined) }}>Remove Image</Button>
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    dummyCouponImage
                    </QuestionHeading>
                    <div className="generic_form_container">
                        <CameraImage image={dummyCouponImage as string} setImage={setDummyCouponImage} currImage={values.dummyCouponImage.value} />
                        <span className="resolution_text">*The image resolution should be 500x500</span>
                        <Button variant="contained" onClick={() => { setValues({ ...values, dummyCouponImage: {...values.dummyCouponImage, value:"",isValueUpdated:true} });
                            setDummyCouponImage(undefined) }}>Remove Image</Button>
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    dummyItemCouponImage
                    </QuestionHeading>
                    <div className="generic_form_container">
                        <CameraImage image={dummyItemCouponImage as string} setImage={setDummyItemCouponImage} currImage={values.dummyItemCouponImage.value} />
                        <span className="resolution_text">*The image resolution should be 500x500</span>
                        <Button variant="contained" onClick={() => { setValues({ ...values, dummyItemCouponImage: {...values.dummyItemCouponImage, value:"",isValueUpdated:true} });
                            setDummyItemCouponImage(undefined) }}>Remove Image</Button>
                    </div>
                </IndentWrapper>

                <div className="form_header">
                    <BorderHeading>SCHEME Configuration</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you want schemes to be visible?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.schemeVisibility.value} onChange={handleCheckChange} name="schemeVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Do you wish to have additional schemes
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.additionalSchemes.value} onChange={handleCheckChange} name="additionalSchemes" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Should there be a pop up on missing schemes?
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.missedSchemeVisibility.value} onChange={handleCheckChange} name="missedSchemeVisibility" label="Yes" />
                    </div>
                </IndentWrapper>

                <div className="form_header">
                    <BorderHeading>Sorting</BorderHeading>
                </div>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    multiVariantSortingOption
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.multiVariantSortingOption.value} onChange={handleValueChange} name="multiVariantSortingOption" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        unnatiCatalogueSorting
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox checked={values.unnatiCatalogueSorting.value} onChange={handleCheckChange} name="unnatiCatalogueSorting" label="Yes" />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                    catalogueSortingType
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleSelectValueChange} value={values.catalogueSortingType.value} name="catalogueSortingType" options={values?.catalogueSortingType?.possibleVals} selectLableId='missed basket' />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>

                <QuestionHeading>
                    sorting options
                </QuestionHeading>
                <div className="language_options_container">
                    {catalogueSortingConfig && catalogueSortingConfig.possibleVals.map(sortingObject => {
                        return (
                            <DashboardCheckbox
                                onChange={handleSortingCheckChange}
                                checked={catalogueSortingConfig.value.map(option => option.name).includes(sortingObject.name)}
                                name={sortingObject.name}
                                label={sortingObject.name}
                            />
                        );
                    })}
                </div>
                </IndentWrapper>



                {/* <div className="form_header">
                    <BorderHeading>SORTING ORDER CONFIGURATION</BorderHeading>
                    <IconButton aria-label="Example" onClick={handleResetFilter}>
                        <FontAwesomeIcon icon={faArrowRotateLeft} />
                    </IconButton>
                </div> */}

                {/* <IndentWrapper indent={0}>
                    <QuestionHeading>
                        SORT ORDER ON THE BASIS OF
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={(e) => setFilterValues({ ...filterValues, [e.target.name]: e.target.value })} value={filterValues.filter1} name="filter1" options={filterOptions.filter(opt => {
                            return (opt.value !== values.catalogueSortingOrder[1] && opt.value !== values.catalogueSortingOrder[2])
                        })} selectLableId='Filter 1' />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        SORT ORDER ON THE BASIS OF
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={(e) => setFilterValues({ ...filterValues, [e.target.name]: e.target.value })} value={filterValues.filter2} name="filter2" options={filterOptions.filter(opt => {
                            return (opt.value !== values.catalogueSortingOrder[0] && opt.value !== values.catalogueSortingOrder[2]) || opt.value === "none"
                        })} selectLableId='Filter 2' />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        SORT ORDER ON THE BASIS OF
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={(e) => setFilterValues({ ...filterValues, [e.target.name]: e.target.value })} value={filterValues.filter3} name="filter3" options={filterOptions.filter(opt => {
                            return (opt.value !== values.catalogueSortingOrder[0] && opt.value !== values.catalogueSortingOrder[1]) || opt.value === "none"
                        })} selectLableId='Filter 3' />
                    </div>
                </IndentWrapper> */}

            </div>
            <ConfigComparePopup message="Are you sure want to update the config" showConfigPopup={showConfigPopup} setShowConfigPopup={setShowConfigPopup} curConfig={curConfigRef.current} newConfig={newConfigRef.current} onSuccess={doFinalCatalogueConfigSubmit} />
        </div>
    )
}

export default CatalogueConfiguration